
import React from 'react';
import { Project, Education, Skill } from './types';

export const PROJECTS: Project[] = [
  {
    id: '1',
    name: 'Stock & Inventory Management System',
    description:
      'A backend-focused stock management system redesigned using a Stock Ledger approach. Supports multi-warehouse inventory tracking, stock reversals, and auditable transaction history.',
    techStack: [
      'Node.js',
      'Express',
      'TypeScript',
      'TypeORM',
      'MySQL'
    ],
    deploymentLink: 'https://anodemo.koneloneshin.com',
    githubLink: ''
  },
  {
    id: '2',
    name: 'QR-Based Coupon Payment System',
    description:
      'A shop payment system that allows shopkeepers to scan QR codes to verify coupons and complete payments. Includes coupon validation,transaction tracking, and admin-side coupon management.',
    techStack: [
      'React',
      'TypeScript',
      'Node.js',
      'Express',
      'TypeORM',
      'PostgreSQL',
      'QR Code',
      'JWT'
    ],
    deploymentLink: 'https://shop.utyccfresher.online',
    githubLink: ''
  },
  {
    id: '3',
    name: 'Secure Voting System - Version 3',
    description:
      'A secure online voting platform built for school-scale elections (~1500 users). Implements PinCode-based voter authorization, admin dashboard for vote monitoring, and strict vote integrity enforcement. I built many versions since 2023 to improve the system. This is the final version and successfully scale to 1500 users.',
    techStack: [
      'React',
      'TypeScript',
      'Node.js',
      'Express',
      'TypeORM',
      'PostgreSQL',
      'JWT'
    ],
    deploymentLink: 'https://utyccfresher.online',
    githubLink: ''
  },
  {
    id: '4',
    name: 'Technologia Club Management AI Bot',
    description:
      'Internal platform and tooling for managing university tech club activities, workshops, and student engagement across cybersecurity, web development, and AI tracks.',
    techStack: [
      'Python',
    ],
    deploymentLink: 'https://t.me/utyccer11011_bot',
    githubLink: 'https://github.com/Radiant-au/Telegram_bot.git'
  },
  {
    id: '5',
    name: 'Smart Event QR & Barcode Verification System',
    description:
      'A smart event management system that verifies attendee entry using QR codes and barcodes. Supports real-time validation, duplicate-scan prevention, and admin-side monitoring for event check-in control.',
    techStack: [
      'React',
      'TypeScript',
      'Node.js',
      'Express',
      'TypeORM',
      'MariaDB',
      'QR Code',
      'Barcode Scanner'
    ],
    deploymentLink: 'https://res.cloudinary.com/dw7kk0lvp/video/upload/v1769887845/save_1_hdefqr.mp4',
    githubLink: 'https://github.com/Radiant-au/Smart_Event.git'
  },
  {
    id: '6',
    name: 'Social Media Platform 🏆',
    description:
      'A full-stack social media platform built with Spring Boot and React. Features include user authentication, posts, likes, comments, and global state management using Redux. 🏆 1st Prize – 3rd Year University Project.',
    techStack: [
      'Spring Boot',
      'Java',
      'React',
      'Redux',
      'REST API',
      'MySQL',
      'JWT'
    ],
    deploymentLink: '',
    githubLink: 'https://github.com/Radiant-au/SocialMedia.git'
  },
  {
    id: '7',
    name: 'The Beat – Music Streaming Platform 🏆',
    description:
      'A music streaming web application supporting playlists, playback, and user authentication. 🏆 1st Prize – 2nd Year University Project.',
    techStack: [
      'Node.js',
      'Express',
      'React',
      'MySQL',
      'HTML',
      'CSS',
      'JavaScript'
    ],
    deploymentLink: '',
    githubLink: 'https://github.com/Radiant-au/TheBeat.git'
  },
  {
    id: '8',
    name: 'HR Management System',
    description:
      'A full-stack HR management system handling employee records, attendance tracking, leave management, and role-based authentication. Designed with modular backend architecture and JWT-based security.',
    techStack: [
      'React',
      'TypeScript',
      'PrimeReact',
      'Tailwind CSS',
      'Node.js',
      'Express',
      'TypeORM',
      'MySQL',
      'JWT'
    ],
    deploymentLink: '',
    githubLink: 'https://github.com/Radiant-au/HR_management.git'
  },
];


export const EDUCATION: Education[] = [
  {
    institution: 'Yadanarpon Cyber City University',
    degree: 'Bachelor of Engineering (Information Science)',
    period: '2019 - Present',
    description:
      'Studied core computer science fundamentals with a strong emphasis on software engineering, database systems, and real-world application development. Actively participated in project-based learning, winning 1st Prize in both 2nd Year and 3rd Year university project competitions through building full-stack systems.'
  }
];


export const SKILLS: Skill[] = [
  {
    category: 'Frontend Development',
    items: [
      'React',
      'TypeScript',
      'Redux',
      'Tailwind CSS',
      'PrimeReact',
      'MUI',
      'Vite',
      'Next.js'
    ]
  },
  {
    category: 'Backend Development',
    items: [
      'Node.js',
      'Express',
      'Spring Boot',
      'Java',
      'RESTful API Design',
      'JWT Authentication'
    ]
  },
  {
    category: 'Database & Data Modeling',
    items: [
      'MySQL',
      'MariaDB',
      'TypeORM',
      'Entity Relationship Design',
      'Transaction & Ledger Modeling'
    ]
  },
  {
    category: 'Cloud & Deployment',
    items: [
      'AWS EC2',
      'AWS Lightsail',
      'Google Cloud Platform (GCP)',
      'Cloud Run',
      'Cloud SQL',
      'Basic Server Provisioning',
      'Environment-Based Configuration'
    ]
  },
  {
    category: 'Tools & Workflow',
    items: [
      'Git',
      'GitHub',
      'Postman',
      'Docker (Basic)',
      'aaPanel',
      'Linux Basics'
    ]
  }
];

export const CONTACT_LINKS = {
  email: 'aks251102@gmail.com',
  github: 'https://github.com/Radiant-au',
  linkedin: 'https://www.linkedin.com/in/aung-kaung-sett-42ba25197/',
};
